module.exports = [
    'PasswordReset',
    '$location',
function (
    PasswordReset,
    $location
) {
    PasswordReset.openReset();
    $location.url('/');
}];



// WEBPACK FOOTER //
// ./app/common/auth/password-reset.controller.js